export default "__VITE_ASSET__CQERTrz8__";